import { IAllCustomersDetails } from "./allCustomers.types";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { api } from "../../api/api";
import { APIError } from "../../constants/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { endPoints } from "../../constants/endPoints";
import { ERROR_MESSAGES } from "../../constants/enums";

export const fetchAllCustomersList = createAsyncThunk<
  {
    data: IAllCustomersDetails[];
  },
  {
    pageNumber: number;
    rowsInPerPage: number;
    limit: number;
    status: string;
    date: IDataTableV2DateState;
    searchValue: IDatatableV2AdvancedSearchFilter;
    otherFilters?: {
      customer_name?: string;
      address?: string;
      customer_id?: string;
      customer_code?: string;
      producer_code?: string;
      branch_code?: string;
      mobile?: string;
      email?: string;
    };
  },
  { rejectValue: APIError }
>(
  "allCustomers/fetchAllCustomersList",
  async ({ pageNumber, rowsInPerPage, limit, status, date, searchValue, otherFilters }, { rejectWithValue }) => {
    try {
      let finalUrl = `${endPoints.customer.fetchAllCustomers}?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}`;

      if(date.rangeType !== "allTimes"){
        finalUrl = finalUrl+ `&to_date=${date.dates.toDate}&from_date=${date.dates.fromDate}`
      }

      // Build combined advance filter: existing searchValue + otherFilters
      const combinedAdvanceFilter = [...searchValue];
      if (otherFilters?.customer_name) {
        combinedAdvanceFilter.push({
          column: ["customer_name"],
          operator: "CONTAINS",
          value: otherFilters.customer_name,
          logicalOperator: "OR",
        });
      }
      if (otherFilters?.address) {
        combinedAdvanceFilter.push({
          column: ["mailing_address"],
          operator: "CONTAINS",
          value: otherFilters.address,
          logicalOperator: "OR",
        });
      }
      if (otherFilters?.customer_id) {
        combinedAdvanceFilter.push({
          column: ["customer_id"],
          operator: "EQUAL",
          value: otherFilters.customer_id,
          logicalOperator: "AND",
        });
      }
      if (otherFilters?.customer_code) {
        combinedAdvanceFilter.push({
          column: ["customer_code"],
          operator: "EQUAL",
          value: otherFilters.customer_code,
          logicalOperator: "AND",
        });
      }
      if (otherFilters?.producer_code) {
        combinedAdvanceFilter.push({
          column: ["producer_code"],
          operator: "EQUAL",
          value: otherFilters.producer_code,
          logicalOperator: "AND",
        });
      }
      if (otherFilters?.branch_code) {
        combinedAdvanceFilter.push({
          column: ["branch_code"],
          operator: "EQUAL",
          value: otherFilters.branch_code,
          logicalOperator: "AND",
        });
      }
      if (otherFilters?.mobile) {
        combinedAdvanceFilter.push({
          column: ["mobile", "phone"],
          operator: "CONTAINS",
          value: otherFilters.mobile,
          logicalOperator: "AND",
        });
      }
      if (otherFilters?.email) {
        combinedAdvanceFilter.push({
          column: ["email"],
          operator: "EQUAL",
          value: otherFilters.email,
          logicalOperator: "AND",
        });
      }

      if (combinedAdvanceFilter.length > 0) {
        finalUrl += `&advanceFilter=${JSON.stringify(combinedAdvanceFilter)}`;
      }

      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      const res = await api.get(finalUrl);
      const data: IAllCustomersDetails[] = res.data.data;
      return {
        data,
      };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);
